import { SeriesRowDataProps } from '@modules/entertainment/models/series.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import { LanguageEnum } from '@models/language.model.ts';

export interface SeriesActionParams {
  data?: SeriesRowDataProps;
  id?: any;
  seriesId?: any;
  state?: any;
  handleClose?: () => void;
  onSuccess?: () => void;
}

export interface SeriesState extends CallStateMethods {
  callState: CallStateEnum;
  genreCallState: CallStateEnum;
  seasonCallState: CallStateEnum;
  genreList: any[];
  seasonsList: any[];
  rawSeasons: any[];
  episodesData: any[];
  episodesPagination: {
    page: number;
    rowsPerPage: number;
    totalPages: number;
  };
  getEpisodes: (params: any) => Promise<any>;
  resetSeasonsList: () => void;
  resetEpisodesList: () => void;
  createRow: (params: SeriesActionParams) => Promise<any>;
  editRow: (params: SeriesActionParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose?: () => void;
  }) => void;
  createGenre: (params: { data: any; handleClose?: () => void }) => void;
  editGenre: (params: { data: any; id: any; handleClose?: () => void }) => void;
  deleteGenre: (params: any) => void;
  getGenreList: () => void;
  getSeasonsList: (id: any) => void;
  setSeasonsListByLanguage: (language: LanguageEnum) => void;
  createSeason: (params: SeriesActionParams) => void;
  editSeason: (params: SeriesActionParams) => void;
  deleteSeason: (params: SeriesActionParams) => void;
  createEpisode: (params: {
    data: any;
    seasonId: string;
    page?: number;
    limit?: number;
    handleClose?: () => void;
  }) => void;
  editEpisode: (params: {
    data: any;
    id?: string;
    seasonId: string;
    page?: number;
    limit?: number;
    handleClose?: () => void;
  }) => void;
  deleteEpisode: (params: {
    id: string | string[];
    seasonId: string;
    page?: number;
    limit?: number;
    handleClose?: () => void;
  }) => void;
  isGenreLoading: () => boolean;
  isGenreLoaded: () => boolean;
  isGenreError: () => boolean;
  isSeasonLoading: () => boolean;
  isSeasonLoaded: () => boolean;
  isSeasonError: () => boolean;
  isEpisodeLoading: () => boolean;
}

interface SeriesStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
  createGenre: 'createGenre';
  editGenre: 'editGenre';
  deleteGenre: 'deleteGenre';
  getEpisodes: 'getEpisodes';
  getGenreList: 'getGenreList';
  getSeasonsList: 'getSeasonsList';
  setSeasonsListByLanguage: 'setSeasonsListByLanguage';
  createSeason: 'createSeason';
  editSeason: 'editSeason';
  deleteSeason: 'deleteSeason';
  createEpisode: 'createEpisode';
  editEpisode: 'editEpisode';
  deleteEpisode: 'deleteEpisode';
  isGenreLoading: 'isGenreLoading';
  isGenreLoaded: 'isGenreLoaded';
  isGenreError: 'isGenreError';
  isSeasonLoading: 'isSeasonLoading';
  isSeasonLoaded: 'isSeasonLoaded';
  isSeasonError: 'isSeasonError';
  resetSeasonsList: 'resetSeasonsList';
  resetEpisodesList: 'resetEpisodesList';
  isEpisodeLoading: 'isEpisodeLoading';
}

export const SERIES_INITIAL_STATE: Omit<SeriesStateMethods, keyof SeriesState> =
  {
    genreList: [],
    rawSeasons: [],
    seasonsList: [],
    episodesData: [],
    episodesPagination: {
      page: 1,
      rowsPerPage: 5,
      totalPages: 1
    },
    callState: CallStateEnum.Init,
    genreCallState: CallStateEnum.Init,
    seasonCallState: CallStateEnum.Init,
    episodeCallState: CallStateEnum.Init,
    isLoadingSeason: false
  };
